import { ComponentPropsWithoutRef } from 'react';
import { fieldStyles } from 'shared/styles/form';
import styled from 'styled-components';

import FormControlProps from 'lib/interfaces/FormControlProps';

export type InputProps = ComponentPropsWithoutRef<'input'> & FormControlProps;

const Input = styled('input').attrs(() => ({
  // Avoid spell-jacking
  spellCheck: false,
}))<InputProps>`
  ${(props) => fieldStyles(props, props.theme)};
`;

export default Input;
